import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';

@Component({
    selector: 'main-exports',
    templateUrl: '../templates/main-exports.html'
})

export class MainExportsComponent implements OnInit {
    
    public minDate: Date = void 0;
    @Input() public initDate: Date;
    
    constructor() {}

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/exports/components/main-exports.component.ts